<template>
<div class="mt-5">
    <h2 class="all text-center">Our all Product</h2>
    <p class="produce text-center">Find your best Product</p>
</div>
</template>

<script>



export default {
 
  data () {
    return {
      
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/page2/head.vue